<div class="otd-list">
  <h1 class="otd-list__title">Venta a fondos</h1>
  <p class="otd-list__lead">
    Facturas en espera de cobranza que puedes vender completas a un fondo. Las particiones de una misma factura se
    venden juntas. Solo aparecen las que tienen 15 días o más de duración restante.
  </p>

  <mat-tab-group class="otd-list__tabs" animationDuration="0ms">
    <mat-tab [label]="'Listas para vender (' + listedInvoices.length + ')'">
      <div class="otd-list__filters">
        <mat-form-field class="otd-list__search" floatLabel="always">
          <mat-label>Busca por RUC o razón social</mat-label>
          <input matInput type="search" placeholder="Ej. 20100113610" (input)="search($event.target.value)" />
        </mat-form-field>

        <app-select
          class="otd-list__currency"
          label="Moneda"
          [options]="currencyOptions"
          [ngModel]="currency"
          (ngModelChange)="changeCurrency($event)"
        ></app-select>
      </div>

      <div class="otd-list__card">
        <table class="otd-list__table" *ngIf="listedInvoices.length">
          <thead>
            <tr>
              <th class="otd-list__check">
                <mat-checkbox
                  color="primary"
                  aria-label="Elegir todas las facturas que se pueden vender"
                  [checked]="allListedSelected"
                  [indeterminate]="selectedIds.size > 0 && !allListedSelected"
                  (change)="toggleAll()"
                ></mat-checkbox>
              </th>
              <th>Factura</th>
              <th>Pagadora y girador</th>
              <th class="otd-list__number">Monto neto</th>
              <th class="otd-list__number">Adelanto</th>
              <th>Vence</th>
              <th class="otd-list__number">Inversionistas</th>
            </tr>
          </thead>
          <tbody>
            <ng-container *ngFor="let invoice of listedInvoices">
            <tr [class.otd-list__row--selected]="selectedIds.has(invoice.id)">
              <ng-container *ngIf="rowCells(invoice) as cells">
                <td class="otd-list__check">
                  <app-checkbox
                    content=""
                    [checked]="selectedIds.has(invoice.id)"
                    (selectionChanged)="toggle(invoice)"
                  ></app-checkbox>
                </td>
                <td class="otd-list__nowrap">
                  <span
                    matTooltipClass="fs-tooltip"
                    [matTooltip]="cells.facturaCompleta"
                    [matTooltipDisabled]="cells.factura === cells.facturaCompleta"
                    >{{ cells.factura }}</span
                  >&ngsp;<button
                    type="button"
                    class="otd-list__partitions-toggle"
                    *ngIf="invoice.partitions"
                    [attr.aria-expanded]="expandedIds.has(invoice.id)"
                    (click)="togglePartitions(invoice)"
                  >{{ invoice.partitions.length }} particiones</button>
                </td>
                <td>
                  {{ cells.pagadora }}
                  <span class="otd-list__secondary">{{ cells.girador }}</span>
                </td>
                <td class="otd-list__number">{{ cells.montoNeto }}</td>
                <td class="otd-list__number">{{ cells.adelanto }}</td>
                <td class="otd-list__nowrap">
                  {{ cells.vence | formatDate }}
                  <span class="otd-list__secondary">{{ cells.diasRestantes }}</span>
                </td>
                <td class="otd-list__number">{{ cells.inversionistas }}</td>
              </ng-container>
            </tr>
            <ng-container *ngIf="expandedIds.has(invoice.id)">
              <tr class="otd-list__partition" *ngFor="let partition of invoice.partitions">
                <ng-container *ngIf="partitionCells(partition) as cells">
                  <td class="otd-list__check"></td>
                  <td class="otd-list__nowrap otd-list__partition-code">{{ cells.factura }}</td>
                  <td>{{ cells.estado }}</td>
                  <td class="otd-list__number">{{ cells.montoNeto }}</td>
                  <td class="otd-list__number">{{ cells.adelanto }}</td>
                  <td></td>
                  <td class="otd-list__number">{{ cells.inversionistas }}</td>
                </ng-container>
              </tr>
            </ng-container>
            </ng-container>
          </tbody>
        </table>

        <p class="otd-list__empty" *ngIf="emptyMessage">{{ emptyMessage }}</p>
        <p class="otd-list__empty" *ngIf="errorMessage">{{ errorMessage }}</p>
      </div>
    </mat-tab>
  </mat-tab-group>

  <div class="otd-list__banner" *ngIf="summary">
    <span class="otd-list__summary">{{ summary }}</span>
    <div class="otd-list__actions">
      <lib-ui-button variant="outline" size="m" label="Quitar selección" (onClick)="clearSelection()"></lib-ui-button>
      <lib-ui-button variant="filled" size="m" label="Vender a fondo" (onClick)="sellToFund()"></lib-ui-button>
    </div>
  </div>
</div>
